import React from "react";
import { Avatar, Box, Card, Typography } from "@mui/material";
import { NoteData } from "../../../utils/types";
import parse from "html-react-parser";
import { dateFromatter, extractNameFromEmail, getAvatarColor, getAvatarInitials } from "../../../utils/utils";

interface NoteTileProps {
  note: NoteData;
  onOpen: (note: NoteData) => void;
}

const NoteTileComponent: React.FC<NoteTileProps> = ({ note, onOpen }) => {
  return (
    <Card className="p2p-note-card" onClick={() => onOpen(note)} sx={{ cursor: "pointer" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 12px",
          borderBottom: "1px solid #eee",
        }}
      >
        <Box sx={{ color: "#A6A6B2", fontSize: "13px" }}>
          {dateFromatter(note?.createdAt || "")}
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <Avatar
          src={note?.pictureUrl || undefined}
          sx={{ 
            width: 24, 
            height: 24,
            bgcolor: !note?.pictureUrl ? getAvatarColor(note.creatorEmail) : undefined,
          }}
        >
          {!note?.pictureUrl && getAvatarInitials(note.creatorEmail)}
        </Avatar>
        <Typography className="user_name">
          {extractNameFromEmail("", note.creatorEmail)}
        </Typography>
      </Box>
      
      </Box>
      <Box
        sx={{
          padding: "17px",
          fontSize: "14px",
          color: "#374151",
          display: "-webkit-box",
          WebkitLineClamp: 5,
          WebkitBoxOrient: "vertical",
          overflow: "hidden"
        }}
      >
        {parse(note.notes || "No content")}
      </Box>
    </Card>
  );
};

export default NoteTileComponent;
